import React from 'react';
import { createStore } from "redux";
import { connect } from "react-redux";

// Actions
const INITIALIZE = "INITIALIZE";
const SET_PRODUCT = "SET_PRODUCT";
const DESELECT_PRODUCT = "DESELECT_PRODUCT";
const PRODUCT_PAGE_CROSSED_CLICKED_ONCE = 'PRODUCT_PAGE_CROSSED_CLICKED_ONCE';

const SET_PURCHASE_COMPLETE = 'SET_PURCHASE_COMPLETE';
const SET_PARAMS = 'SET_PARAMS';
const UPDATE_PRODUCT_PURCHASE_CONTEXT = 'UPDATE_PRODUCT_PURCHASE_CONTEXT'

// Initial State
const initialState = (data) =>{
  var selectedProduct = null;
  if(data.products.length == 1 && !data.upgradable){
    selectedProduct = data.products[0];
  }

  return {
    studentId: null,
    fromPage: null,
    currentUser: data.current_user || {},
    students: data.students || [],
    products: data.products || [],
    settings: { ...data.settings, skipSignUp: localStorage.getItem('skipSignUp') } || {},
    selectedProduct: selectedProduct,
    purchaseComplete: false,
    upgradeAble: data.upgradable || false,
    currentPlan: data.current_product || null,
    otherProducts: data.other_products || [],
    refundableAmount: data.refundable_amount || null,
    subscriptionPlatform: data.subscription_platform || null,
    blockUpgrade: data.block_upgrade || false,
    restrictionInfoStore: data.selected_mode ? {
      availableModes: data.available_modes,
      refreshTime: data.refresh_time,
      selected_mode: data.selected_mode
    }: null,
    ptlParent: data.ptlParent,
    parentDobYear: data.parentDobYear,
    sameSubjectUpgrade: data.same_subject_upgrade || false,
    monthOfUpgradation: data.month_of_upgradation,
    subscriptionDetails: data.subscription || null,
    stripePaymentElement: data.stripePaymentElement || null
  }
};

// Root Reducer
export const rootReducer = (state = {}, action) => {
  switch (action.type) {
    case INITIALIZE:
      return initialState(action.payload);
    case SET_PRODUCT:
      return {...state, selectedProduct: action.payload};
    case DESELECT_PRODUCT:
      return {...state, selectedProduct: null};
    case SET_PURCHASE_COMPLETE:
      return {...state, purchaseComplete: true, subscriptionDetails:action.payload};
    case SET_PARAMS:
      return {...state, studentId: action.payload.studentId, fromPage: action.payload.fromPage}
    case PRODUCT_PAGE_CROSSED_CLICKED_ONCE:
      return {
        ...state,
        settings: {
          ...state.settings,
          video_on_cross_enabled: true
        }
      }
    case UPDATE_PRODUCT_PURCHASE_CONTEXT:
      return {
        ...state, 
        ...action.payload
      }
      default:
      return state;
  }
};


const Store = createStore(rootReducer);

export default function ConnectWithStore(mapStateToProps, dispatchStateToProps, component){
  var ConnectedComponent = connect(mapStateToProps, dispatchStateToProps)(component);
  return function(props){
    return <ConnectedComponent {...props} store={Store}/>
  }
}


